module.exports = __webpack_public_path__ + "img/TheVeryLastPizzaCredits.0d76c0c7.png";